import { handleIdentify } from './rudder_analytics';

const subscribe = ({ email, csrftoken, slug, is_tct, rudder_anonymous_id }) =>
  fetch('/subscribe/', {
    method: 'POST',
    headers: {
      'X-CSRFToken': csrftoken,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email, slug, is_tct, rudder_anonymous_id })
  }).then(result => {
    handleIdentify(email);
    const contentType = result.headers.get('content-type');
    if (contentType && contentType.indexOf('application/json') > -1) {
      return result.json();
    } else {
      return result;
    }
  });

window.addEventListener("load", async () => {
  const parsedUrl = new URL(window.location.href);

  if (parsedUrl.searchParams.get("f") === "new-card") {
    document.getElementById("access-form-container").scrollTo();
  }

  const paywall_content = document.getElementById("post-preview");
  const paywall_modal = document.getElementById("access-form-container");

  paywall_modal.style.transition = "visibility 1s, opacity 1s";
  paywall_modal.style.opacity = "0";
  paywall_modal.style.display = "flex";
  paywall_modal.style.visibility = "hidden";

  window.addEventListener("scroll", () => {
    //This "debounces" the scroll listener so it doesn't run too often
    window.requestAnimationFrame(() => {
      if (paywall_content.getBoundingClientRect().top < 500) {
        paywall_modal.style.opacity = "1";
        paywall_modal.style.visibility = "visible";
      } else if (paywall_content.getBoundingClientRect().top > 500) {
        paywall_modal.style.opacity = "0";
        paywall_modal.style.visibility = "hidden";
      }
    });
  });

  const paywall_form = document.getElementById("content-paywall-form");
  if (paywall_form) {
    paywall_form.addEventListener("submit", async (e) => {
      e.preventDefault();

      const formData = new FormData(paywall_form);
      const data = Object.fromEntries(formData.entries());

      const csrftoken = document.querySelector('[name=csrfmiddlewaretoken]').value;
      const is_tct = window.location.href.includes('/p/') || window.location.href.includes('/the-cap-table/');
      const rudder_anonymous_id = window.rudderanalytics && window.rudderanalytics?.getAnonymousId();
      const slug = '';
      subscribe({ email: data.email, slug, csrftoken, is_tct, rudder_anonymous_id }).then(response => {
        if (response.ok) {
          location.href = '/onboarding/checkout?email=' + encodeURIComponent(data.email);
        } else {
          console.error('Failed to subscribe')
        }
      });
    });
  }
});
